import React from "react";
import {
  sendChatLogic,
  sendChatNotification,
  uploadChatImages,
} from "../../../store/features/chat/chatSlice";
import { getFullName, notify, playMessageSound } from "../../../util/helpers";
import S3FileUpload from "react-s3";
import { RtcTokenBuilder, RtmTokenBuilder } from "agora-access-token";

export const getRTCToken = (
  agoraID,
  agoraCertificate,
  uid,
  role,
  privilegeExpriyTime,
  channelName = null
) => {
  if (!channelName) {
    channelName = uid.toString();
  }
  let token = null;
  try {
    token = RtcTokenBuilder.buildTokenWithUid(
      agoraID,
      agoraCertificate,
      channelName,
      uid.toString(),
      role,
      privilegeExpriyTime
    );
  } catch (e) {
    console.log(
      "Something went wrong while generating RTC token from Agora",
      e
    );
  }
  return token;
};

export const getToken = (
  agoraID,
  agoraCertificate,
  uid,
  role,
  privilegeExpriyTime
) => {
  let token = "";
  try {
    token = RtmTokenBuilder.buildToken(
      agoraID,
      agoraCertificate,
      uid,
      role,
      privilegeExpriyTime
    );
  } catch (e) {
    console.log("Something went wrong while generating RTM Token", e);
  }
  return token;
};

export const chatStructureHelper = (
  item,
  filteredData,
  clinicianId,
  clinicianName,
  clinicAdmin
) => {
  const patientData = item?.patient_data;
  let structure = {};
  if (patientData) {
    const patientName = getFullName(patientData);
    const identifier = patientData["id"];
    const sentBy = (item?.sender === clinicianId || item?.sender === clinicAdmin) ? clinicianName : patientName;
    const messageStrucure = {
      message_type: item?.message_type,
      message: item?.message,
      created: item?.created,
      modified: item?.modified,
      sentBy: sentBy,
      messageId: item?.id,
      sender: item?.sender,
      to: item?.to,
      type: (item?.sender === clinicianId || item?.sender === clinicAdmin) ? "outgoing" : "incoming",
    };
    if (identifier in filteredData) {
      filteredData[identifier]["messages"].push(messageStrucure);
      if (item?.read_status === false) {
        if ("count" in filteredData[identifier]) {
          filteredData[identifier]["count"] += 1;
        } else {
          filteredData[identifier]["count"] = 1;
        }
      }
    } else {
      structure = {
        name: patientName,
        patient_id: patientData?.id,
        flag: patientData?.flag,
        profile_picture: patientData?.profile_picture,
        email: patientData?.email,
        latest_message:
          item?.message_type === "text" ? item?.message : "Sent an image",
        latest_message_time: new Date(item?.modified),
        sentBy: sentBy,
        messageId: item?.id,
        sender: item?.sender,
        to: item?.to,
        count: 0,
        messages: [messageStrucure],
        rose_chat: patientData?.rose_chat,
      };
      filteredData[identifier] = structure;
    }
    return structure;
  }
};

export const messageStrucureHelper = (
  item,
  clinicianId,
  clinicianName,
  patientName
) => {
  const messageStrucure = {
    message_type: item?.message_type,
    message: item?.message,
    created: new Date(), //TODO Send created from backend
    modified: new Date(), //TODO Send modified from backend
    sentBy: item?.sender === clinicianId ? clinicianName : patientName,
    messageId: item?.id || 9999999, //TODO Send messageID from backend
    sender: item?.sender,
    to: item?.to,
    type: item?.sender === clinicianId ? "outgoing" : "incoming",
  };

  return messageStrucure;
};

export const updateMessageInSidebar = (
  message,
  peerId,
  chatPatients,
  setChatPatients,
  updateBadge
) => {
  try {
    peerId = parseInt(peerId);
    //*Checking if the patient's chat tile exists:
    let tempChatList = JSON.parse(JSON.stringify(chatPatients));
    let chatTile = tempChatList.findIndex(
      (chat) => chat?.patient_id === peerId
    );
    const now = new Date();
    if (chatTile !== -1) {
      tempChatList[chatTile].latest_message = message?.text;
      tempChatList[chatTile].latest_message_time = now;
      tempChatList[chatTile].created = now;
      if (updateBadge) {
        tempChatList[chatTile]["count"] = tempChatList[chatTile]?.count
          ? parseInt(tempChatList[chatTile]?.count) + 1
          : 1;
      }
      //*Add the new patient tile to the list of running chats in chatPatients state and update the state variable.
      setChatPatients(tempChatList);

      //*Finally, notify the clinician about the new message
      if (updateBadge) {
        playMessageSound();
      }
    } else {
      //*Modify chatPatients state to include the new chatitem

      //*Create a strucutrue for the new message
      let message = {
        message_type: message?.messageType,
        message: message?.text,
        created: now,
        modified: now,
        messageId: 9999999, //TODO: Change this be next after existing messages / 0 if it is a new message
        sender: peerId,
        to: clinicianId,
        type: "incoming",
      };

      //* Find the patient from the list of chat-enabled patients already made available with the first UE and update latest message details and add new message to list of messages for that patient.
      const findPatient = chatEnabledPatients.find(
        (patient) => patient?.patient_id === peerId
      );
      findPatient.latest_message = message?.message;
      findPatient.latest_message_time = now;
      findPatient.created = now;
      findPatient.sender = peerId;
      findPatient.messages = [message];
      findPatient.to = clinicianId;
      findPatient["count"] = 1;

      //*Add the new patient tile to the list of running chats in chatPatients state and update the state variable.
      tempChatList.push(findPatient);
      setChatPatients(tempChatList);

      //*Finally, notify the clinician about the new message
      playMessageSound();
    }
  } catch (e) {
    console.log("Error while updating messages in sidebar\n", e);
  }
};

// export const handleImageUploadToS3 = async (attachment, path) => {
//   const config = {
//     bucketName: process.env.REACT_APP_AWS_BUCKET,
//     dirName: path,
//     region: process.env.REACT_APP_AWS_REGION,
//     accessKeyId: process.env.REACT_APP_AWS_KEY_ID,
//     secretAccessKey: process.env.REACT_APP_AWS_SECRET,
//   };

//   if (!attachment) return;
//   S3FileUpload.uploadFile(attachment, config)
//     .then((data) => {
//       return data;
//     })
//     .catch((e) => {
//       console.log("Something went wrong while uploading to S3", e);
//     });
// };
export const handleImageUploadToS3 = async (attachment, path) => {
  if (!attachment) return null;

  const formData = new FormData();
  formData.append("file", attachment);
  formData.append("path", path); // Optional sub-folder

  try {
    const res = await uploadChatImages(formData);
    return res?.data?.url || null; // Public S3 URL returned by backend
  } catch (e) {
    console.error("Something went wrong while uploading to backend", e);
    return null;
  }
};


export const sendMessage = async (
  type,
  peerID,
  message = null,
  setMessageSending = null,
  setMessageText = null,
  setClinicianChatMessage = null,
  clinicianId = null,
  attachment = null,
  setAttachment = null,
  patientEmail = null,
  senderName = null,
) => {
  const payloadMessageStructure = {
    message_type: type,
    message: message?.text,
    read_status: true,
    to: peerID.toString(),
    sender: clinicianId.toString(),
  };

  const rtmHelper = (
    payload = payloadMessageStructure,
    text = message?.text
  ) => {
    agora
      .sendMessageToPeer(
        {
          // text: `${text} [From : ${senderName}]`,
          text: text,
          messageType: "TEXT",
        },
        peerID.toString()
      )
      .then((sendResult) => {
        if (!sendResult.hasPeerReceived) {
          // console.log("Message sent but patient has not recieved the message!");
          if (patientEmail) {
            sendChatNotification(patientEmail)
              .then((res) => {
                console.log("Notified");
              })
              .catch((e) => {
                console.log(e);
              });
          }
        }
        // console.log("payload-sendChat", payload);
        sendChatLogic(payload)
          .then((res) => {
            if (res.status === 201) {
              setClinicianChatMessage({
                messageType: type,
                text: text,
              });
              ///TODO Update latest message text in sidebar
            }
          })
          .catch((e) => {
            console.log("API send message error", e);
            notify(
              "Something went wrong while sending your message, try again later!",
              "warning"
            );
          });
      })
      .catch((e) => {
        console.log("Agora send message error", e.message);
        notify(
          "Something went wrong while sending your message, try again later!",
          "warning"
        );
      });
    if (setAttachment) {
      setAttachment(null);
    }
  };

  try {
    setMessageSending(true);

    // if (type === "image") {
    //   const config = {
    //     bucketName: process.env.REACT_APP_AWS_BUCKET,
    //     dirName: `${clinicianId.toString()}/${peerID.toString()}`,
    //     region: process.env.REACT_APP_AWS_REGION,
    //     accessKeyId: process.env.REACT_APP_AWS_KEY_ID,
    //     secretAccessKey: process.env.REACT_APP_AWS_SECRET,
    //   };

    //   if (!attachment) return;
    //   S3FileUpload.uploadFile(attachment, config)
    //     .then((data) => {
    //       const temp = { ...payloadMessageStructure };
    //       temp["message"] = `${data?.location} [From : ${senderName}]`;
    //       console.log ("old:-", temp,data?.location)
    //       rtmHelper(temp, data?.location);
    //       //text: `${text} [From : ${senderName}]`,
    //     })
    //     .catch((e) => {
    //       console.log("Something went wrong while uploading to S3", e);
    //     });
    // } 
    if (type === "image") {
      if (!attachment) return;
    
      const formData = new FormData();
      formData.append("file", attachment);
      formData.append("path", `${clinicianId}/${peerID}`);
    
      uploadChatImages(formData)
      .then((res) => {
      const imageUrl = res?.data?.url;

      if (!imageUrl) {
        console.error("Image URL is missing in upload response", res);
        return;
      }

      const temp = { ...payloadMessageStructure };
      temp["message"] = `${imageUrl} [From : ${senderName}]`;
      console.log ("new:-", temp,imageUrl)
      rtmHelper(temp, imageUrl);
     })
        .catch((e) => {
         console.error("Upload error", e);
      });
    }
    else {
      rtmHelper();
    }
  } catch (e) {
    console.log("Something went wrong while sending message", e);
  }
  setMessageSending(false);
  setMessageText("");
};
const AgoraClientComponent = ({ callback = null, setRemoteShow = null }) => {
  //*Chat Initialization stuff
  const client = window?.agora;

  client?.on("ConnectionStateChanged", async (data, data2) => {
    if (data === "ABORTED" && data2 === "REMOTE_LOGIN") {
      if (setRemoteShow) {
        setRemoteShow(true);
      }
    }
  });

  client?.on("MessageFromPeer", (message, peerID) => {
    console.log(`${peerID} texted :`, message); //TODO: Remove this log once testing is completed!
    if (callback) {
      callback(message, peerID);
    } else {
      //notify("You have a new message!", "info");
    }
  });

  return <></>;
};

export default AgoraClientComponent;
